export const LogoIcon = () => {
  return (
    <svg viewBox="0 0 395.52 247.2" height="1em" width="1em">
      <g transform="matrix(1,0,0,1,121.32907391304347,47.215199999999996)">
        <svg viewBox="0 0 152.86185217391304 152.7696" height="152.7696" width="152.86185217391304">
          <g>
            <svg viewBox="0 0 152.86185217391304 152.7696" height="152.7696" width="152.86185217391304">
              <g>
                <svg viewBox="0 0 152.86185217391304 152.7696" height="152.7696" width="152.86185217391304">
                  <g>
                    <svg viewBox="0 0 152.86185217391304 152.7696" height="152.7696" width="152.86185217391304">
                      <g>
                        <svg viewBox="0 0 152.86185217391304 152.7696" height="152.7696" width="152.86185217391304">
                          <g>
                            <svg viewBox="0 0 152.86185217391304 152.7696" height="152.7696" width="152.86185217391304">
                              <g transform="matrix(1,0,0,1,0,0)">
                                <svg
                                  width="152.86185217391304"
                                  viewBox="2.2699999809265137 -40.43000030517578 40.45000076293945 40.43000030517578"
                                  height="152.7696"
                                  data-palette-color="#0080ff"
                                >
                                  <path
                                    d="M24.8-10.55L12.82-10.55 12.82-29.88Q12.82-29.88 24.8-29.88L24.8-29.88Q27.71-29.88 29.8-27.04 31.88-24.19 31.88-20.21L31.88-20.21Q31.88-16.21 29.8-13.38 27.71-10.55 24.8-10.55L24.8-10.55ZM14.58-28.13L14.58-12.3 24.8-12.3Q26.98-12.3 28.53-14.62 30.08-16.94 30.08-20.21L30.08-20.21Q30.08-23.51 28.53-25.82 26.98-28.13 24.8-28.13L24.8-28.13 14.58-28.13ZM11.06-31.64L11.06-8.79 24.8-8.79Q28.44-8.79 31.07-12.15 33.69-15.5 33.69-20.21L33.69-20.21Q33.69-23.32 32.48-25.95 31.27-28.59 29.24-30.11 27.2-31.64 24.8-31.64L24.8-31.64 11.06-31.64ZM24.8-7.03L9.3-7.03 9.3-33.4 24.8-33.4Q27.66-33.4 30.13-31.64 32.59-29.88 34.05-26.84 35.5-23.8 35.5-20.21L35.5-20.21Q35.5-16.65 34.05-13.6 32.59-10.55 30.13-8.79 27.66-7.03 24.8-7.03L24.8-7.03ZM7.54-35.16L7.54-5.27 24.8-5.27Q28.15-5.27 31.02-7.28 33.89-9.28 35.6-12.72 37.3-16.16 37.3-20.21L37.3-20.21Q37.3-24.24 35.6-27.7 33.89-31.15 31.01-33.15 28.13-35.16 24.8-35.16L24.8-35.16 7.54-35.16ZM24.8-3.52L5.79-3.52 5.79-36.91 24.8-36.91Q28.61-36.91 31.91-34.68 35.21-32.45 37.16-28.59 39.11-24.73 39.11-20.21 39.11-15.7 37.16-11.84 35.21-7.98 31.91-5.75 28.61-3.52 24.8-3.52L24.8-3.52ZM4.03-38.67L4.03-1.76 24.8-1.76Q28-1.76 30.98-3.22 33.96-4.69 36.13-7.15 38.31-9.62 39.61-13.05 40.92-16.48 40.92-20.21 40.92-23.95 39.61-27.37 38.31-30.79 36.13-33.26 33.96-35.74 30.98-37.21 28-38.67 24.8-38.67L24.8-38.67 4.03-38.67ZM24.8 0L24.8 0 2.27 0 2.27-40.43 24.8-40.43Q29.57-40.43 33.69-37.72 37.82-35.01 40.27-30.35 42.72-25.68 42.72-20.21L42.72-20.21Q42.72-16.11 41.27-12.37 39.82-8.62 37.4-5.91 34.99-3.2 31.68-1.6 28.37 0 24.8 0Z"
                                    opacity="1"
                                    transform="matrix(1,0,0,1,0,0)"
                                    fill="#0080ff"
                                    data-fill-palette-color="primary"
                                    id="text-0"
                                  ></path>
                                </svg>
                              </g>
                            </svg>
                          </g>
                        </svg>
                      </g>
                    </svg>
                  </g>
                </svg>
              </g>
            </svg>
          </g>
        </svg>
      </g>
      <path
        d="M91.89 41.215L91.89 0 339.09 0 339.09 247.2 91.89 247.2 91.89 205.985 105.667 205.985 105.667 233.423 325.313 233.423 325.313 13.777 105.667 13.777 105.667 41.215Z"
        fill="#0080ff"
        stroke="transparent"
        data-fill-palette-color="primary"
      ></path>
    </svg>
  );
};
